import { getAppConfig } from '@/actions/app-action';
import logger from '@/lib/edge-logger';
import { AppConfig } from '@/config/app';
import { create } from 'zustand';

interface AppInfo {
  loginBgImage?: string
  loginLogoImage?: string
  sidebarLogoImage?: string
  title?: string
  description?: string
  slogan?: string
  slogan_sub?: string
  title_cn?: string
  tenant?: string
}

interface AppStore {
  appInfo: AppInfo;
  loading: boolean;
  loadAppConfig: () => Promise<void>;
  updateAppInfo: (newInfo: Partial<AppInfo>) => void;
}

const useAppStore = create<AppStore>()(
  (set, get) => ({
    // 使用app.ts中的配置作为初始值
    appInfo: {
      tenant: AppConfig.info.tenantCode
    },
    loading: false,
    loadAppConfig: async () => {
      set({ loading: true });
      try {
        const config = await getAppConfig();
        if (config && config.content) {
          // 从主数据获取配置并覆盖初始值
          set({
            appInfo: {
              ...get().appInfo,
              ...config.content
            }
          });
        }
      } catch (error) {
        logger.error('Failed to load app config from master data:', error);
        // 出错时继续使用app.ts中的配置
      } finally {
        set({ loading: false });
      }
    },
    updateAppInfo: (newInfo: Partial<AppInfo>) => {
      set({
        appInfo: {
          ...get().appInfo,
          ...newInfo
        }
      });
    }
  })
);

export default useAppStore;